export interface InteractionDto {
  id: string;
  name: string;
  clientId: string;
  isZoomEnabled: boolean;
  pageLayout: InteractionsCardsPageLayoutEnum;
  createdAt: string;
  updatedAt: string;
  interactionsGroups: InteractionGroupDto[];
}

export interface InteractionGroupDto {
  id: string;
  interactionId: string;
  name: string;
  order: number;
  score: number;
  status: string;
  isResults: boolean;
  createdAt: string;
  updatedAt: string;
  interactionsCards: InteractionCardDto[];
}

export interface InteractionCardDto {
  id: string;
  type: InteractionsCardsTypeEnum;
  isTitle: boolean;
  isText: boolean;
  isRequired: boolean;
  isMultiselect: boolean;
  isRolePlay: boolean;
  isNoCorrect: boolean;
  title: string;
  titleColor: string;
  text: string;
  legend1: string;
  legend2: string;
  text1: string;
  text2: string;
  comment: string;
  url1: string;
  url2: string;
  minSelect: number;
  maxSelect: number;
  ratingType: InteractionCardsRatingTypeEnum;
  score: number;
  color: string;
  backgroundColor: string;
  backgroundImage: string;
  backgroundPosition: InteractionCardsBackgroundPositionEnum;
  backgroundSize: InteractionCardsBackgroundSizeEnum;
  backgroundOverlay: InteractionCardsBackgroundOverlayEnum;
  interactionsCardCategories: InteractionsCardCategoryDto[];
  interactionsCardItems: InteractionsCardItemDto[];
  cardAnswer: InteractionCardAnswerDto;
}

export interface InteractionsCardCategoryDto {
  id: string;
  interactionsCardId: string;
  text: string;
  title: string;
  isText: boolean;
  order: number;
}

export interface InteractionsCardItemDto {
  id: string;
  text: string;
  textAnswer: string;
  comment: string;
  isValid: boolean;
  score: number;
  order: number;
  correctOrder: number;
  interactionCardCategoryId: string;
  cardItemAnswer: InteractionCardItemAnswerDto;
}

export interface InteractionCardAnswerDto {
  id: string;
  interactionCardId: string;
  score: number;
  isCompleted: boolean;
  isPassed: boolean;
  groupExtId: number;
  userId: string;
  formAnswer: any;
  createdAt: string;
  updatedAt: string;
}

export interface InteractionCardItemAnswerDto {
  id: string;
  interactionsCardItemId: string;
  value: number;
  valueText: string;
  score: number;
}

export interface InteractionAnswerSaveDto {
  interactionCardId: string;
  score: number;
  isPassed: boolean;
  isCompleted: boolean;
  groupExtId: number;
  text: string;
  InteractionAnswerItems: InteractionAnswerItemSaveDto[];
}

export interface InteractionAnswerItemSaveDto {
  interactionsCardItemId: string;
  value?: number;
  valueText?: string;
  score: number;
}

export interface CardQuestionnaireOptionDto {
  isSelected: boolean,
  value?: number | undefined,
  valueText?: string | undefined,
  item: InteractionsCardItemDto
}

export interface CardQuestionnaireCategoryDto extends InteractionsCardCategoryDto {
  options: CardQuestionnaireOptionDto[];
}

export interface ResultsDto {
  range?: string[];
  items: ResultsItemDto[];
}

export interface ResultsItemDto {
  value: number;
  label: string;
  title: string;
  status: string;
  options?: ResultsItemOptionsDto[];
}

export interface ResultsItemOptionsDto {
  value: number;
  label: string;
  title: string;
  status: string;
}

export interface StatisticsDto {
  interactionCardId: string;
  groupExtId: number;
  interactionCardAnswersCount: number;
  interactionCardAnswersPassed: number;
  interactionCardAnswerItems: StatisticsItemDto[];
  interactionCardAnswerItemsValues: StatisticsItemValueDto[];
  phrases: StatisticsFormPhraseDto[];
}

export interface StatisticsFormPhraseDto {
  phrase: string;
  frequency: number;
  importance: number;
}

export interface StatisticsItemDto {
  InteractionAnswerItemsAvg: string;
  InteractionAnswerItemsCount: number;
  interactionsCardItemId: string;
}

export interface StatisticsItemValueDto {
  InteractionAnswerItemsCount: number;
  interactionsCardItemId: string;
  value: number;
}

export interface EmojiDto {
  name: string;
  userId: number;
  userFullName: string;
}

export enum InteractionsCardsPageLayoutEnum {
  dockBottom = 'dockBottom',
  dockLeft = 'dockLeft',
}

export enum InteractionsCardsTypeEnum {
  text = 'text',
  form = 'form',
  quiz = 'quiz',
  poll = 'poll',
  video = 'video',
  audio = 'audio',
  button = 'button',
  dragAndDrop = 'dragAndDrop',
  dragAndMatch = 'dragAndMatch',
  dragToGroup = 'dragToGroup',
  rating = 'rating',
}

export enum InteractionCardsBackgroundPositionEnum {
  fullscreen = 'fullscreen',
  top = 'top',
  bottom = 'bottom',
}

export enum InteractionCardsBackgroundSizeEnum {
  auto = 'auto',
  p25 = '25%',
  p50 = '50%',
  p75 = '75%',
}

export enum InteractionCardsBackgroundOverlayEnum {
  auto = 'auto',
  none = 'none',
}

export enum InteractionCardsRatingTypeEnum {
  stars = 'stars',
  buttons = 'buttons',
}

export const EMOJIS = [
  { name: 'Red Heart', code: '\u2764\uFE0F' },
  { name: 'Smiling Face with Heart-Eyes', code: '\uD83D\uDE0D' },
  { name: 'Thumbs Up', code: '\uD83D\uDC4D' },
  { name: 'Thumbs Down', code: '\uD83D\uDC4E' },
  { name: 'Grinning Face', code: '\uD83D\uDE00' },
  { name: 'Clapping Hands', code: '\uD83D\uDC4F' }
];
